/**
 * Каскад «Водій → ТЗ» (як у задачах): водій перевізника — лише ТЗ цього перевізника;
 * власний водій (без перевізника) — ТЗ власних перевізників. Бекенд перевіряє те саме
 * (для власного водія допускає й ТЗ без перевізника, але в списку їх не пропонуємо).
 */

/** IRI зі значення select-поля: рядок або об'єкт ресурсу з `@id` */
export const iriOf = (value: any): string | null => {
    if (!value) return null
    if (typeof value === 'string') return value
    return typeof value['@id'] === 'string' ? value['@id'] : null
}

/** uuid користувача з IRI `/services/users/<uuid>` або об'єкта з `uuid` */
export const userUuidOf = (value: any): string | null => {
    if (!value) return null
    if (typeof value === 'object' && typeof value.uuid === 'string') return value.uuid
    const iri = iriOf(value)
    return iri ? iri.split('/').pop() || null : null
}

/** Код перевізника (первинне поле довідника): об'єкт з `code` або останній сегмент IRI */
export const carrierCodeOf = (value: any): string | null => {
    if (!value) return null
    if (typeof value === 'object' && typeof value.code === 'string' && value.code) return value.code
    const iri = iriOf(value)
    return iri ? iri.split('/').pop() || null : null
}

/** Фільтр опцій ТЗ для перевізника водія; undefined — водія не обрано */
export const vehicleFilterFor = (driverCarrier: any | undefined): Record<string, any> => {
    if (driverCarrier === undefined) return { isActive: true }
    const carrierCode = carrierCodeOf(driverCarrier)
    return carrierCode ? { isActive: true, 'carrier.code': carrierCode } : { isActive: true, 'carrier.isOwn': true }
}
